import { useEffect, useState } from 'react';
import {
  useGetUserPreferencesQuery,
  UserPreferences,
} from '../../slices/userPreferences/userPreferencesSlice';
import { useAuth } from 'src/common/Auth';

function useUserPreferences() {
  const { isAuthenticated } = useAuth();
  const cacheKey = 'cached-user-preferences';
  const { data, isFetching } = useGetUserPreferencesQuery(undefined, {
    skip: !isAuthenticated,
  });
  const [userPreferences, setUserPreferences] = useState<
    UserPreferences | undefined
  >(() => {
    const cachedPreferences = localStorage.getItem(cacheKey);
    try {
      if (cachedPreferences === null) {
        return undefined;
      }
      return JSON.parse(cachedPreferences) as UserPreferences;
    } catch {
      return undefined;
    }
  });

  useEffect(() => {
    if (!isFetching && data) {
      localStorage.setItem(cacheKey, JSON.stringify(data));
      setUserPreferences(data);
    }
  }, [isFetching]);

  return {
    userPreferences: userPreferences,
    isLoaded: userPreferences || !isFetching,
  };
}

export default useUserPreferences;
